'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MastheadExtensionSubscriptionButtons = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _LoginButton = require('../LoginButton');

var _LoginButton2 = _interopRequireDefault(_LoginButton);

var _SubscribeButton = require('../SubscribeButton');

var _SubscribeButton2 = _interopRequireDefault(_SubscribeButton);

var _props = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
var renderSubscribeButton = function renderSubscribeButton(loggedIn, theme, mastheadExtension, engagement, attributes, mainMenuOpened) {
    return loggedIn ? null : _react2.default.createElement(_SubscribeButton2.default, {
        theme: theme,
        mastheadExtension: mastheadExtension,
        engagement: engagement,
        attributes: attributes,
        focusable: !mainMenuOpened
    });
};

var MastheadExtensionSubscriptionButtons = exports.MastheadExtensionSubscriptionButtons = function MastheadExtensionSubscriptionButtons(props) {
    var mastheadExtension = props.mastheadExtension,
        theme = props.theme,
        loggedIn = props.loggedIn,
        widgets = props.widgets,
        engagement = props.engagement,
        attributes = props.attributes,
        loginFirst = props.loginFirst,
        mainMenuOpened = props.mainMenuOpened;

    var loginButton = _react2.default.createElement(_LoginButton2.default, {
        theme: theme,
        mastheadExtension: mastheadExtension,
        widgets: widgets,
        engagement: engagement,
        attributes: attributes,
        focusable: !mainMenuOpened
    });

    return _react2.default.createElement(
        'span',
        { className: theme.buttonsWrapper },
        loginFirst && loginButton,
        renderSubscribeButton(loggedIn, theme, mastheadExtension, engagement, attributes, mainMenuOpened),
        !loginFirst && loginButton
    );
};

if (process.env.NODE_ENV !== 'production') {
    MastheadExtensionSubscriptionButtons.propTypes = {
        attributes: _propTypes2.default.func,
        engagement: _propTypes2.default.func,
        loggedIn: _propTypes2.default.bool,
        loginFirst: _propTypes2.default.bool,
        mainMenuOpened: _propTypes2.default.bool,
        mastheadExtension: _propTypes2.default.shape(_props.mastheadExtensionProps).isRequired,
        widgets: _propTypes2.default.shape({
            WeatherWidget: _propTypes2.default.func
        }),
        theme: _propTypes2.default.shape({
            buttonsWrapper: _propTypes2.default.string
        })
    };
}

MastheadExtensionSubscriptionButtons.defaultProps = {
    attributes: function attributes() {},
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    loggedIn: false,
    loginFirst: false,
    theme: {},
    mainMenuOpened: false
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        loggedIn: state.spid.loggedIn,
        mainMenuOpened: state.coreNavigationUI.main.mainMenuOpened
    };
})(MastheadExtensionSubscriptionButtons);
//# sourceMappingURL=MastheadExtensionSubscriptionButtons.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MastheadExtensionSubscriptionButtons/MastheadExtensionSubscriptionButtons.js
 ** module id = 611
 ** module chunks = 1
 **/